import Banner from "../Components/Banner"
import Information from "../Information"

const Home = () => {
    return (
        <div className="App">
            <Banner></Banner>
            <Information></Information>
        </div>
    )
}

export default Home
